import { createQuery } from '@luna/api';
import { PublicService, type UserType } from '@api-client/temporary-messages';
import { isFeatureEnabled } from '@luna/gatekeeper';

import { getApplicationType } from './TemporaryMessagesApplicationTypeService';

export const [useTemporaryMessages, { updateCache: updateTemporaryMessagesCache }] = createQuery({
    name: 'temporaryMessages/messages',
    condition: () => isFeatureEnabled((f) => f.temporaryMessages),
    payloadCreator: async (userType: UserType) => {
        const { items } = await PublicService.getPublicTemporaryMessages({
            xApplicationType: getApplicationType(),
            userType,
        });

        return items;
    },
});
